module.exports = __webpack_public_path__ + "img/asmntproginactive.65af9ffd.svg";